var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 20.75V5.75C5.25 5.35218 5.40804 4.97064 5.68934 4.68934C5.97064 4.40804 6.35218 4.25 6.75 4.25H14.25C14.6478 4.25 15.0294 4.40804 15.3107 4.68934C15.592 4.97064 15.75 5.35218 15.75 5.75V20.75",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.75H18",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11H18C18.3978 11 18.7794 11.158 19.0607 11.4393C19.342 11.7206 19.5 12.1022 19.5 12.5V16.25C19.5 16.6478 19.658 17.0294 19.9393 17.3107C20.2206 17.592 20.6022 17.75 21 17.75C21.3978 17.75 21.7794 17.592 22.0607 17.3107C22.342 17.0294 22.5 16.6478 22.5 16.25V8.61875C22.4983 8.22139 22.34 7.84073 22.0594 7.55938L20.25 5.75",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11H8.25",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.78e9f11db6a70f207c04eb3ccd5229db.svg";
export { ForwardRef as ReactComponent };